import { render, staticRenderFns } from "./CompetitorEdit.vue?vue&type=template&id=d04c335c"
import script from "./CompetitorEdit.vue?vue&type=script&lang=js"
export * from "./CompetitorEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports